import React from 'react'
import Navbar from "../Include/Navbar";
import Footer from "../Include/Footer";
function RefundPolicy() {
  return (
    <>
    <Navbar/>
    <div className="about-page">
      <div className="container">
        <h1>Refund & Cancellation Policy</h1>
        <p>
          To the fullest extent permitted by applicable laws, all subscription
          payments made on our platform are final and non-refundable. This
          applies regardless of whether the services have been accessed or
          utilized.
        </p>
        <p>
          Once a subscription is purchased, it remains valid for the entire
          duration of the selected billing cycle (“Subscription Term”). If you
          choose to cancel your subscription at any time, the cancellation will
          only prevent future renewals. Your current subscription will continue
          until the end of the active Subscription Term.
        </p>
        <p>
          We do not provide refunds, credits, or adjustments for:
        </p>
        <ul>
          <li>Partially used subscription periods</li>
          <li>Unused or unwatched content</li>
          <li>Early cancellation during an active billing cycle</li>
        </ul>
        <p>
          Any request to modify or change your subscription plan will be
          processed after the completion of your current Subscription Term. The
          updated plan will only become effective once the existing billing
          cycle ends and the applicable payment for the new plan is successfully
          completed.
        </p>
        <section className="section">
          <h2>Return & Shipping Policy</h2>
          <p>
            As we offer digital services and content, there are no physical
            products involved. Therefore:
          </p>
          <ul>
            <li>
              We do not provide returns, replacements, or exchanges
            </li>
            <li>
              No shipping or delivery is applicable
            </li>
            <li>
              All services are delivered and accessed online through our
              platform
            </li>
          </ul>
          <p>
            Once subscribed, users can access the available content digitally as
            per their selected plan.
          </p>
        </section>
      </div>
    </div>
    <Footer/>
    </>
  )
}
export default RefundPolicy